import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";

export enum LandingRoutes {
    MAIN = "/",
    AR = "/ar",
    INVERSOR = "/inversor",
    DESARROLLADORES = "/desarrolladores",
    BROKERS = "/brokers",
    INMOBILIARIAS = "/inmobiliarias",
    ACTIVIO_ANALISTA = "/activio-analista",
}

const HomePage = lazy(() => import("./page/HomePage"));
const LandingPage = lazy(() => import("./LandingPage"));
const DesarrolladoresPage = lazy(() => import("./page/DesarrolladoresPage"));
const BrokersPage = lazy(() => import("./page/BrokersPage"));
const InmobiliariasPage = lazy(() => import("./page/InmobiliariasPage"));
const ActivioAnalistaPage = lazy(() => import("./page/ActivioAnalistaPage"));

export const LandingRouter = (
    <>
        <Route path={LandingRoutes.MAIN} element={<LandingPage />} />
        <Route path={LandingRoutes.AR} element={<Navigate to={LandingRoutes.MAIN} replace />} />
        <Route path={LandingRoutes.INVERSOR} element={<LandingPage />} />
        <Route path="/inversores" element={<Navigate to={LandingRoutes.INVERSOR} replace />} />
        <Route path={LandingRoutes.DESARROLLADORES} element={<DesarrolladoresPage />} />
        <Route path={LandingRoutes.BROKERS} element={<BrokersPage />} />
        <Route path={LandingRoutes.INMOBILIARIAS} element={<InmobiliariasPage />} />
        <Route path={LandingRoutes.ACTIVIO_ANALISTA} element={<ActivioAnalistaPage />} />
    </>
);
